import React from "react";
import { Avatar, Box, Chip } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const ChipFilledSize = () => {

  return (
    <Box sx={{ mb: 2 }}>
      <PreviewAndEditor
        title={"Basic Filled Chip Size"}
        language={"js"}
        value={"" +
            "<Chip\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          size=\"medium\"\n" +
            "          label=\"Chip Medium\"\n" +
            "          onDelete={() => console.log(\"On Delete\")}\n" +
            "          onClick={() => console.log(\"On Click\")}\n" +
            "        />\n" +
            "        <Chip\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          size=\"small\"\n" +
            "          label=\"Chip Small\"\n" +
            "          onDelete={() => console.log(\"On Delete\")}\n" +
            "          onClick={() => console.log(\"On Click\")}\n" +
            "        />\n" +
            "        <Chip\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          size=\"xSmall\"\n" +
            "          label=\"Chip xSmall\"\n" +
            "          onDelete={() => console.log(\"On Delete\")}\n" +
            "          onClick={() => console.log(\"On Click\")}\n" +
            "        />"}
      >
        <Chip
          avatar={<Avatar>H</Avatar>}
          size="medium"
          label="Chip Medium"
          onDelete={() => console.log("On Delete")}
          onClick={() => console.log("On Click")}
        />
        <Chip
          avatar={<Avatar>H</Avatar>}
          size="small"
          label="Chip Small"
          onDelete={() => console.log("On Delete")}
          onClick={() => console.log("On Click")}
        />
        <Chip
          avatar={<Avatar>H</Avatar>}
          size="xSmall"
          label="Chip xSmall"
          onDelete={() => console.log("On Delete")}
          onClick={() => console.log("On Click")}
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default ChipFilledSize;
